


















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import router from '@/router'
import { ETemplateType } from '@/models/dtos/enums/eTemplateType'
import { SelectMixin } from '@/mixins/SelectMixin'
import { TemplateAdminService as _templateAdminService } from '@/admin/services/templateAdmin.service'
import { TemplateMixin } from '@/mixins/templateMixin'
import { TemplateDto } from '@/models/dtos/templateDto'
import { SelectDto } from '@/models/dtos/selectDto'
import { ValidationObserver } from 'vee-validate'

@Component
export default class AdminTempateCreateOrUpdate extends mixins(TemplateMixin, SelectMixin) {
  // Ref
  $refs!: {
    templateForm: InstanceType<typeof ValidationObserver>;
  }

  // Data
  private templateId: string | null = null
  private template: TemplateDto | null = null
  private templateTypesSelect: SelectDto[] = []

  // Methods
  private async initTemplate() {
    this.templateId = (this.$route.params as any)?.id || null

    this.template = {
      type: ETemplateType.Company,
      shorthand: '',
      fullName: ''
    } as TemplateDto

    if (this.templateId) {
      this.template = await _templateAdminService.get(this.templateId) || this.template
    }
  }

  private initTemplateTypesSelect() {
    this.templateTypesSelect = this.mapEnumToSelect(ETemplateType, this.templateName, [])
  }

  private async saveOrUpdate(evt: any) {
    evt.preventDefault()

    const isValid = await this.$refs.templateForm.validate()
    if (!isValid) return

    if (!this.templateId) {
      const templateId = await _templateAdminService.add(this.template!)
      router.push({ name: 'AdminTemplateEdit', params: { id: templateId.toString() } })
    } else {
      _templateAdminService.edit(this.template!)
    }
  }

  // Getters
  private get isLoaded(): boolean {
    return !this.template
  }

  // Lifecycle
  async created() {
    this.initTemplateTypesSelect()
    this.initTemplate()
  }

  // Watchers
  @Watch('$route')
  async onRouteChange() {
    this.initTemplate()
    this.$refs.templateForm.reset()
  }
}
